import { Validators } from '@angular/forms';
import { TableCols } from '../interfaces/static-data';
import { LEGAL_JURISDICTIONS } from 'src/app/shared/consts/legal-juristictions.const';
import { uniqBy } from 'lodash';

export const CONTACTS: TableCols[] = [
  {
    key: 'deskId',
    displayValue: 'Desk',
    type: 'select',
    validators: [Validators.required],
  },
  {
    key: 'name',
    displayValue: 'Name',
    validators: [Validators.required],
  },
  {
    key: 'email',
    displayValue: 'Email',
    validators: [Validators.email],
  },
  {
    key: 'location',
    displayValue: 'Location',
    type: 'select',
    items: uniqBy(LEGAL_JURISDICTIONS, 'id')
      .sort((a, b) => a.displayValue.localeCompare(b.displayValue))
      .map(({ id, displayValue }) => ({
        id,
        displayValue,
      })),
  },
];
